/*
 * Copyright 2022, TeamDev. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Redistribution and use in source and/or binary forms, with or without
 * modification, must retain the above copyright notice and the following
 * disclaimer.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
 * A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT
 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
 * LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
 * DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY
 * THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
 * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DirectClientFactory = void 0;

var _actorRequestFactory = require("./actor-request-factory");

var _anyPacker = require("./any-packer");

var _clientFactory = require("./client-factory");

var _commandingClient = require("./commanding-client");

var _compositeClient = require("./composite-client");

var _httpClient = require("./http-client");

var _httpEndpoint = require("./http-endpoint");

var _knownTypes = _interopRequireDefault(require("./known-types"));

var _queryingClient = require("./querying-client");

var _subscribingClient = require("./subscribing-client");

var _typedMessage = require("./typed-message");

var _typeParsers = _interopRequireDefault(require("./parser/type-parsers"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * An implementation of the `AbstractClientFactory` that creates instances of client which exchanges
 * data with the server directly.
 *
 * Querying is performed by sending a query to the server over HTTP and reading the query response
 * from the HTTP response.
 *
 * This client does not support subscriptions.
 */
var DirectClientFactory = /*#__PURE__*/function (_AbstractClientFactor) {
  _inherits(DirectClientFactory, _AbstractClientFactor);

  var _super = _createSuper(DirectClientFactory);

  function DirectClientFactory() {
    _classCallCheck(this, DirectClientFactory);

    return _super.apply(this, arguments);
  }

  _createClass(DirectClientFactory, null, [{
    key: "_clientFor",
    value: function _clientFor(options) {
      var httpClient = new _httpClient.HttpClient(options.endpointUrl);
      var endpoint = new _httpEndpoint.HttpEndpoint(httpClient, options.routing);

      var requestFactory = _actorRequestFactory.ActorRequestFactory.create(options);

      var querying = new DirectQueryingClient(endpoint, requestFactory);
      var subscribing = new _subscribingClient.NoOpSubscribingClient(requestFactory);
      var commanding = new _commandingClient.CommandingClient(endpoint, requestFactory);
      return new _compositeClient.CompositeClient(querying, subscribing, commanding);
    }
  }, {
    key: "createQuerying",
    value: function createQuerying(options) {
      var httpClient = new _httpClient.HttpClient(options.endpointUrl);
      var endpoint = new _httpEndpoint.HttpEndpoint(httpClient, options.routing);

      var requestFactory = _actorRequestFactory.ActorRequestFactory.create(options);

      return new DirectQueryingClient(endpoint, requestFactory);
    }
  }, {
    key: "createSubscribing",
    value: function createSubscribing(options) {
      var requestFactory = _actorRequestFactory.ActorRequestFactory.create(options);

      return new _subscribingClient.NoOpSubscribingClient(requestFactory);
    }
    /**
     * @override
     */

  }, {
    key: "_ensureOptionsSufficient",
    value: function _ensureOptionsSufficient(options) {
      _get(_getPrototypeOf(DirectClientFactory), "_ensureOptionsSufficient", this).call(this, options);

      var messageForMissing = function messageForMissing(option) {
        return "Unable to initialize a direct client. The ClientOptions.".concat(option, " not specified.");
      };

      if (!options.endpointUrl) {
        throw new Error(messageForMissing('endpointUrl'));
      }

      if (!options.actorProvider) {
        throw new Error(messageForMissing('actorProvider'));
      }
    }
  }]);

  return DirectClientFactory;
}(_clientFactory.AbstractClientFactory);
/**
 * A {@link QueryingClient} which reads entity states directly from the server.
 */


exports.DirectClientFactory = DirectClientFactory;

var DirectQueryingClient = /*#__PURE__*/function (_QueryingClient) {
  _inherits(DirectQueryingClient, _QueryingClient);

  var _super2 = _createSuper(DirectQueryingClient);

  /**
   * An internal `DirectQueryingClient` constructor.
   *
   * Use `FirebaseClient#usingFirebase()` for instantiation.
   *
   * @param {!HttpEndpoint} endpoint the server endpoint to execute queries and commands
   * @param {!ActorRequestFactory} actorRequestFactory a factory to instantiate the actor requests with
   *
   * @protected
   */
  function DirectQueryingClient(endpoint, actorRequestFactory) {
    var _this;

    _classCallCheck(this, DirectQueryingClient);

    _this = _super2.call(this, actorRequestFactory);
    _this._endpoint = endpoint;
    return _this;
  }

  _createClass(DirectQueryingClient, [{
    key: "read",
    value: function read(query) {
      var typeUrl = query.getTarget().getType();

      var targetClass = _knownTypes["default"].classFor(typeUrl);

      var targetType = _typedMessage.Type.of(targetClass, typeUrl);

      var responseParser = _typeParsers["default"].parserFor('type.spine.io/spine.client.QueryResponse');

      return this._endpoint.query(query).then(function (response) {
        var message = responseParser.fromObject(response);
        var entityStates = message.getMessageList();
        return entityStates.map(function (entity) {
          return DirectQueryingClient._unpack(entity, targetType);
        });
      });
    }
  }], [{
    key: "_unpack",
    value: function _unpack(entity, targetType) {
      var unpacker = _anyPacker.AnyPacker.unpack(entity.getState());

      return unpacker.as(targetType);
    }
  }]);

  return DirectQueryingClient;
}(_queryingClient.QueryingClient);
//# sourceMappingURL=direct-client.js.map